import NP from 'number-precision'
// import { copyColumns } from "@/views/purchase/shipments/constant"
import { clearLsAll, getLsPermission } from '@/core/storage/ls'
import dayjs from 'dayjs'
import JsSHA from 'jssha'
import { getLsUserInfo } from '@/core/storage/ls'
import { getGlobalData } from '@/core/global-data'
import { regionData } from 'element-china-area-data'
import { useSlots } from 'vue'
import CryptoJS from 'crypto-js'
import { ElMessage } from 'element-plus'
import { $t } from '@/i18n'

export function np_divide() {
  const args = arguments
  if (args.length === 1) {
    Array.prototype.push.call(args, 100)
  }
  return NP.divide.apply(null, args)
}

export function getCurrencyCodeText(withBracket = false) {
  const currencyCode = getGlobalData('currency_code')
  if (!currencyCode) return ''
  return withBracket ? `(${currencyCode})` : currencyCode
}

export function np_times() {
  const args = arguments
  if (args.length === 1) {
    Array.prototype.push.call(args, 100)
  }
  return NP.times.apply(null, args)
}

/**
 * 添加千分号，保留N位小数
 * @param {Number} val 需要处理的数字
 * @param {Number} num 保留的小数位
 * @returns  {String}
 */
export function numFormat(val, num = 2) {
  if (typeof val === 'number' && !isNaN(val)) {
    val = String(val)
    let left = val.split('.')[0] //整数部分
    let right = val.split('.')[1] //小数部分
    right = right
      ? right.length >= num
        ? right.substr(0, num)
        : right +
        Array(num - right.length)
          .fill(0)
          .join('')
      : Array(num).fill(0).join('')
    let temp = left
      .split('')
      .reverse()
      .join('')
      .match(/(\d{1,3})/g)
    return (
      (Number(val) < 0 ? '-' : '') +
      temp.join(',').split('').reverse().join('') +
      (right ? '.' + right : '')
    )
  } else {
    return ''
  }
}

/**
 * 文件大小 KB 和 M G 的转换
 * @param {number} bytes 文件的字节数
 * @returns {string} 文件大小的字符串表示形式
 * @returns {String}
 */
export function formatFileSize(bytes) {
  const units = ['BT', 'KB', 'M', 'G']
  let size = bytes
  let unitIndex = 0
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024
    unitIndex++
  } // 保留两位小数，四舍五入
  size = Math.round(size * 100) / 100
  return `${ size } ${ units[unitIndex] }`
}

/**
 * 判断是否为图片文件
 * @param {String} str 文件后缀
 * @returns {Boolean}
 */
export function isImageType(str) {
  // toLowerCase() 将字符串转换为小写，返回一个新的字符串
  return (
    [
      'png',
      'jpg',
      'jpeg',
      'bmp',
      'gif',
      'webp',
      'psd',
      'svg',
      'tiff'
    ].indexOf(str.toLowerCase()) !== -1
  )
}

//深拷贝
export function deepClone(obj, cache = new WeakMap()) {
  if (obj === null || typeof obj !== 'object') return obj
  if (obj instanceof Date) return new Date(obj)
  if (obj instanceof RegExp) return new RegExp(obj)

  if (cache.get(obj)) return cache.get(obj) // 如果出现循环引用，则返回缓存的对象，防止递归进入死循环
  let cloneObj = new obj.constructor() // 使用对象所属的构造函数创建一个新对象
  cache.set(obj, cloneObj) // 缓存对象，用于循环引用的情况

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      cloneObj[key] = deepClone(obj[key], cache) // 递归拷贝
    }
  }
  return cloneObj
}

//带逗号的金额字符串，转换成数字
//例如：28,520.85 -> 28520
export function commaNumber(str) {
  let num = String(str).replace(/[,]+/g, '')
  return Number(num)
}

//控制输入的内容只包括：数字，小数点后两位
export function controlAmount(str) {
  str = String(str)
  str = str.replace(/[^\d.]/g, '') //清除"数字"和"."以外的字符
  str = str.replace(/^\./g, '') //验证第一个字符是数字
  str = str.replace(/\.{2,}/g, '.') //只保留第一个, 清除多余的
  str = str.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  str = str.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
  return str
}

export function numberToChinese(number) {
  const chineseNumerals = [
    '零',
    '一',
    '二',
    '三',
    '四',
    '五',
    '六',
    '七',
    '八',
    '九'
  ]
  // 将数字转换为字符串
  const numStr = Math.floor(number).toString()

  // 获取中文数字的位置（十、百、千）
  function getChinesePosition(position) {
    const positions = ['', '十', '百', '千']
    return positions[position]
  }

  // 检查数字是否合法
  if (!numStr.match(/^\d{1,4}$/)) {
    throw new Error('输入的数字不合法')
  }

  // 处理特殊情况
  if (numStr === '0') {
    return chineseNumerals[0]
  }

  // 将数字字符转换为中文数字字符
  let chineseNumeral = ''
  let zeroFlag = false // 用于标记是否需要添加零
  for (let i = 0; i < numStr.length; i++) {
    const digit = parseInt(numStr[i])
    const position = numStr.length - i - 1

    if (digit === 0) {
      zeroFlag = true
    } else {
      if (zeroFlag) {
        chineseNumeral += chineseNumerals[0]
        zeroFlag = false
      }
      chineseNumeral += chineseNumerals[digit]
      if (position > 0) {
        chineseNumeral += getChinesePosition(position)
      }
    }
  }

  // 如果以"一十"开头，则去掉"一"
  if (chineseNumeral.startsWith('一十')) {
    chineseNumeral = chineseNumeral.substring(1)
  }

  return chineseNumeral
}

// 动态表单   参数(获取后端的数据，表单title的总数据数组)
// arr：获取后端的数据
// arr1：表单title的总数据数组
export function newColumns(arr, arr1, selection) {
  let filterArr = []
  let newArr = []
  if (arr.length > 0) {
    // 拿全部的看过滤出勾选中的
    arr1.forEach(item => {
      arr.map(item2 => {
        if (item2.component === item.prop) {
          filterArr.push(item)
        }
      })
    })
    if (selection) {
      // 勾选中的结合基础的
      newArr = [
        {
          type: 'selection',
          width: 40,
          fixed: 'left'
        },
        ...filterArr
      ]
    } else {
      newArr = [...filterArr]
    }
  } else {
    newArr = [...copyColumns]
  }
  // 根据order排序
  newArr.sort((a, b) => {
    return a.order - b.order
  })
  return newArr
}

// 防抖函数
export function debounce(fn, delay) {
  let timer = null
  return function temp(...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

// 判断该组件是否有插槽组件
export function isHasSlotComponent(name) {
  const slots = useSlots()
  return slots.hasOwnProperty(name) ? true : false
}

// file对象转路径url
export function getObjectURL(file) {
  var url = null
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(file)
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file)
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file)
  }
  return url
}

// 获取文件路径的类型
export function getFileUrlType(url) {
  if (!url) return ''
  return url.split('.').at(-1).toLowerCase()
}

// 获取文件路径的名字
export function getFileUrlName(url) {
  if (!url) return ''
  return url.split('/').at(-1).toLowerCase()
}

// 生成随机字符串
export function generateRandomString(length = 8) {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return result
}

// 设置路由title
export function setDocumentTitle(title) {
  document.title = title
  const ua = navigator.userAgent
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe')
    i.src = '/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}

// encrypt加密
export function encryptedPassword(text) {
  const jssha256 = new JsSHA('SHA-256', 'TEXT')
  jssha256.update(text)
  return jssha256.getHash('HEX')
}

export function downfileByUrl(url) {
  const a = document.createElement('a')
  a.href = url
  a.target = '__blank'
  a.click()
}

function hoursZeroize(num) {
  if (num < 10) {
    return `0${ num }:00`
  }
  return `${ num }:00`
}

const weekcha = {
  0: '周日',
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六'
}

// 枚举一天的24小时
export function dayOfHours() {
  const arrMap = new Map()
  for (let i = 0; i < 24; i++) {
    const item = {
      txtX: `${ hoursZeroize(i) }`,
      date_time: `${ hoursZeroize(i) }`,
      deal_amount: 0,
      deal_count: 0
    }
    arrMap.set(hoursZeroize(i), item)
  }
  return arrMap
}

// 枚举当天倒推days天
export function daysOfDay(days) {
  const arrMap = new Map()
  const now = new Date().getTime()
  for (let i = days - 1; i >= 0; i--) {
    const timestamp = now - 24 * 3600 * 1000 * i
    const day = dayjs(timestamp).format('YYYY-MM-DD')
    const itme = {
      date_time: day,
      deal_count: 0,
      deal_amount: 0
    }
    if (days === 7) {
      itme.txtX = weekcha[dayjs(day).day()]
    }
    if (days === 30) {
      itme.txtX = dayjs(timestamp).format('MM-DD')
    }
    arrMap.set(day, itme)
  }
  return arrMap
}

/**
 * 时间枚举函数
 * @param {number} count - 数量：天数、月数或年数
 * @param {string} type - 类型：'day' | 'month' | 'year'
 * @param {Object} options - 配置选项
 * @param {number} options.yearCount - 按年查询时的年数（默认12年）
 * @returns {Map} 返回时间枚举的Map对象
 */
export function timeEnum(count, type = 'day', options = {}) {
  const arrMap = new Map()
  const now = dayjs()
  
  // 配置选项
  const yearCount = options.yearCount || 12

  switch (type) {
    case 'day':
      // 按日枚举：倒推count天（包括当天）
      for (let i = count - 1; i >= 0; i--) {
        const targetDate = now.subtract(i, 'day')
        const dateStr = targetDate.format('YYYY-MM-DD')
        const item = {
          date_time: dateStr,
          deal_count: 0,
          deal_amount: 0,
          txtX: targetDate.format('MM-DD')
        }
        arrMap.set(dateStr, item)
      }
      break

    case 'month':
      // 按月枚举：倒推count个月（包括当月）
      for (let i = count - 1; i >= 0; i--) {
        const targetMonth = now.subtract(i, 'month')
        const monthStr = targetMonth.format('YYYY-MM')
        const item = {
          date_time: monthStr,
          deal_count: 0,
          deal_amount: 0,
          txtX: count <= 12 
            ? `${targetMonth.month() + 1}月`  // 12个月内显示"X月"
            : `${targetMonth.year()}年${targetMonth.month() + 1}月` // 超过12个月显示完整年月
        }
        arrMap.set(monthStr, item)
      }
      break

    case 'year':
      // 按年枚举：倒推count年（包括当年），默认最多12年
      const years = count || yearCount
      for (let i = years - 1; i >= 0; i--) {
        const targetYear = now.subtract(i, 'year')
        const yearStr = targetYear.format('YYYY')
        const item = {
          date_time: yearStr,
          deal_count: 0,
          deal_amount: 0,
          txtX: yearStr  // 年份直接显示
        }
        arrMap.set(yearStr, item)
      }
      break

    default:
      throw new Error('不支持的type参数，请使用: day, month 或 year')
  }

  return arrMap
}

/**
 * 获取日枚举（与原函数保持兼容）
 * @param {number} days - 天数
 * @returns {Map} 返回日枚举Map
 */
export function daysOfDays(days) {
  return timeEnum(days, 'day')
}

/**
 * 获取月枚举
 * @param {number} months - 月数（默认12）
 * @returns {Map} 返回月枚举Map
 */
export function monthsOfMonth(months = 12) {
  return timeEnum(months, 'month')
}

/**
 * 获取年枚举
 * @param {number} years - 年数（默认12）
 * @returns {Map} 返回年枚举Map
 */
export function yearsOfYear(years = 3) {
  return timeEnum(years, 'year')
}


/* 
对regionData进行处理二级区域，省市
*/
export function provinceAndCityDataHandle() {
  console.log(regionData, 'regionData')
  let provinceAndCityData = []
  provinceAndCityData = regionData.map(province => ({
    value: province.value,
    label: province.label,
    children: province.children.map(city => ({
      value: city.value,
      label: city.label
    }))
  }))
  return {
    provinceAndCityData,
    regionData
  }
}

export function encrypt(word) {
  let AES_KEY = 'xhemoJMJzmL0YqII4d6dI6rty0CFoZBz' // 密钥

  const key = CryptoJS.enc.Utf8.parse(AES_KEY)
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

export const loadQRCodeScript = () => {
  return new Promise((resolve, reject) => {
    if (window.QRCode) {
      return resolve(window.QRCode) // 如果已加载，则直接返回
    }

    const script = document.createElement('script')
    // 使用绝对路径加载脚本
    script.src = '/js/qrcode.js'
    script.onload = () => resolve(window.QRCode)
    script.onerror = () => reject(new Error('Failed to load QRCode script.'))
    document.body.appendChild(script)
  })
}


export async function generateQrCode(text) {
  try {
    const QRCode = await loadQRCodeScript() // 加载脚本
    return await QRCode.toDataURL(text) // 生成二维码 URL
  } catch (error) {
    console.error('QR code generation failed:', error)
    return null
  }
}

// 商品模板排序
export function getTemplateUtil(data) {
  const obj = {}
  data.sort((pre, next) => {
    const [preLayer, preCurr] = pre.sensor.split('-').map(Number)
    const [nextLayer, nextCurr] = next.sensor.split('-').map(Number)
    return preLayer - nextLayer || preCurr - nextCurr
  })
  data.forEach((item) => {
    const num = Number.parseInt(item.sensor, 10)
    obj[num] = obj[num] || []
    if (item.goods_code) {
      obj[num].push({
        ...item
      })
    } else {
      obj[num].push({
        sensor: item.sensor
      })
    }
  })
  return obj
}

/* 输出今天、本月、本季度、本年 开始和结束时间 */
export const timeLineFormat = (timePoint = `day`, format = `YYYY-MM-DD HH:mm:ss`, sub = 0) => {
  return {
    [`${ timePoint.toUpperCase() }_START`]: dayjs().subtract(sub, 'day').startOf(timePoint).format(format),
    [`${ timePoint.toUpperCase() }_END`]: dayjs().subtract(sub, 'day').endOf(timePoint).format(format)
  }
}

// 定义element-plus水印参数
export function getWaterMarkContent() {
  const userInfo = getLsUserInfo()
  const content = [`${ userInfo.name } ${ userInfo.phone.slice(-4) } ${ dayjs().format('YYYY-MM-DD') }`]
  const font = {
    color: 'rgba(0, 0, 0, .15)'
  }
  return { content, font }
}


// 脱敏处理
// val -> 需要进行脱敏处理的内容
// front -> 前面需要保留的位数
// after -> 后面需要保留的位数

export function addStar(val, front, after) {
  return val.substring(0, front) + '*'.repeat(val.length - (front + after)) + val.substring(val.length - after)
}

/* 判断是否具有某种权限 */

/*
	permissionName: 权限名称
*/
export function authPermission(permissionName) {
  const permissionList = getLsPermission()
  return permissionList.includes(permissionName)
}

/* 路由跳转鉴权 */

/*
	permissionName: 权限名称
	path: 跳转地址
*/
export function routerJumpAuth(permissionName, path, router) {
  console.log(`跳转鉴权`)
  if (authPermission(permissionName)) {
    router.push(path)
  } else {
    ElMessage.warning($t('common.PermissionNot'))
  }
}

/**
 * 填充默认时间
 * @param dateStr 时间字符串
 * @param minYear 开始时间
 * @param maxYear 结束时间
 * @returns {*|string} 处理后时间
 */
export function fullDefaultDate(dateStr, minYear = 1960, maxYear = 1979) {
  if (!dateStr) return '--'
  const match = dateStr.match(/^(\d{4})-\d{2}-\d{2}/)
  if (match) {
    const year = parseInt(match[1])
    if (year >= minYear && year <= maxYear) {
      return '--'
    }
  }
  return dateStr
}

// 判断是否是JSON字符串
export function isJSON(str) {
  if (typeof str !== 'string') return false
  try {
    const obj = JSON.parse(str)
    return obj && typeof obj === 'object'
  } catch {
    return false
  }
}

/**
 * 浏览器中下载图片文件（整合版）
 * @param {string} url 图片地址
 * @param {string} fileName 下载文件名
 */
export async function downloadImage(url, fileName) {
  try {
    const image = await new Promise((resolve, reject) => {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = `${ url }?time=${ Date.now() }`
      img.onload = () => resolve(img)
      img.onerror = (err) => reject(new Error('图片加载失败: ' + err))
    })

    const canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(image, 0, 0)
    const base64 = canvas.toDataURL('image/png')

    const link = document.createElement('a')
    link.href = base64
    link.download = fileName
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    console.error('下载图片失败:', error)
  }
}

/**
 * 复制到剪贴板
 * @param {string} text
 */
export function copyTextToClipboard(text) {
  text = text.replace(/\s+/g, '')
  // 首选使用 Clipboard API
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(() => {
      ElMessage.success($t('common.copySuccess'))
    }).catch(err => {
      console.error('Clipboard API 失败：', err)
    })
  } else {
    // 回退方法：创建一个临时 textarea
    const textarea = document.createElement('textarea')
    textarea.value = text
    // 避免显示在页面上
    textarea.style.position = 'fixed'
    textarea.style.top = '-9999px'
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()
    try {
      const successful = document.execCommand('copy')
      if (successful) {
        ElMessage.success($t('common.copySuccess'))
      } else {
        console.error('复制失败！')
      }
    } catch (err) {
      console.error('execCommand 失败：', err)
    }
    document.body.removeChild(textarea)
  }
}

// 国际化长文本切割
export function longStringSplice(string,index){
  return  string.split(/(?=\d+[、.]\s*)/g).filter(item => item.trim())[index]
}

// 获取文字长度
export const getTextWidth = (text, fontStyle = '400 13px "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif') => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  context.font = fontStyle
  return context.measureText(text+':').width
}

/**
 * 手机号脱敏展示（仅用于页面展示，查询/复制/拨打/提交等仍用完整号码）
 * - 只遮数字、保留非数字字符（+、空格、-）原位，兼容各国号段
 * - 数字 8~10 位（HK/MY 等本地号）：统一保留前 2 位与尾 4 位，中间打 *
 *   8 位  91234567   → 91**4567
 *   9 位  123456789  → 12***6789
 *   10 位 2025551234 → 20****1234
 * - 数字 ≥11 位（含国际号段）：保留前 2 位与尾 4 位
 *   +60123456789 → +6*****6789；中国 13812345678 → 13*****5678
 * - 数字 5~7 位：保留前 2 位与尾 2 位（短号保护，避免星号占比失衡）
 * - 数字 ≤4 位：不脱敏（过短无法辨识）
 * - 值含 *（后端已脱敏）原样返回，避免二次脱敏搅乱星号位置
 * - 空/非文本原样返回，由调用处自行做 '-' 兜底
 */
export function maskPhone(value) {
  if (value === null || value === undefined) return value;
  const str = String(value);
  if (str.includes('*')) return str; // 后端已脱敏，直接展示
  const total = str.replace(/\D/g, '').length;
  if (total <= 4) return str;
  // 8 位及以上统一保留前 2、尾 4；5~7 位短号保留前 2、尾 2
  const head = 2;
  const tail = total >= 8 ? 4 : 2;
  let seen = 0;
  return str.replace(/\d/g, (d) => {
    seen += 1;
    return seen <= head || seen > total - tail ? d : '*';
  });
}
